module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_02-4ef65e143de58d7d32d4d6e2a411d50a.png";